import store from 'store'
import actions from './actions'
import { config } from '../../config';
import toggleStylesheet from '../../helpers/toggleStylesheet';
import { getItemFromStore, setItemToStore, themeColors } from '../../helpers/utils';

const STORED_SETTINGS = storedSettings => {
  const settings = {}
  Object.keys(storedSettings).forEach(key => {
    const item = store.get(`app.settings.${key}`)
    settings[key] = typeof item !== 'undefined' ? item : storedSettings[key]
  })
  return settings
}

const initialState = {
  ...STORED_SETTINGS({
    authProvider: 'varexeLogin', 
    logo: 'varexe',
    locale: 'en-US',
    isSidebarOpen: false,
    isSupportChatOpen: false,
    isMobileView: false,
    isMobileMenuOpen: false,
    isMenuCollapsed: false,
    menuLayoutType: 'left', // left only delete in future
    routerAnimation: 'zoom-fadein', // none, slide-fadein-up, slide-fadein-right, fadein, zoom-fadein
    menuColor: 'gray', // white, dark, gray
    theme: 'default', // default, dark
    authPagesColor: 'gray', // white, gray, image
    primaryColor: '#4b7cf3',
    leftMenuWidth: 266,
    isMenuUnfixed: false,
    isMenuShadow: false,
    isTopbarFixed: false,
    isGrayTopbar: false,
    isContentMaxWidth: false,
    isAppMaxWidth: false,
    isGrayBackground: false,
    isCardShadow: true,
    isSquaredBorders: false,
    isBorderless: true,
  }),
}

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
